import { render } from "./Rocket.vue?vue&type=template&id=0b5fb362"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Rocket.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b5fb362"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b5fb362', __exports__)) {
    api.reload('0b5fb362', __exports__)
  }
  
  module.hot.accept("./Rocket.vue?vue&type=template&id=0b5fb362", () => {
    api.rerender('0b5fb362', render)
  })

}


export default __exports__